import { CivilUnionVM } from 'mutation/view-models/civil-union';
import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';

export const transformerPersonToCivilUnion = (person?: SubjectData): CivilUnionVM => {
  const response: CivilUnionVM = {
    citizenship: {
      id: (person?.cittadinanza || [])[0]?.codiceStato || '',
      value: (person?.cittadinanza || [])[0]?.descrizioneStato || '',
    },
    from: (person?.cittadinanza || [])[0]?.dataValidita
      ? DateTime.fromISO((person?.cittadinanza || [])[0]?.dataValidita || '')
      : null,
    note: (person?.cittadinanza || [])[0]?.noteStato || undefined,
    disabled: person?.generalita?.codiceFiscale?.codFiscale ? true : false, // if there is response is disabled
    unionOrder: person?.unioneCivile?.ordineUnione,
    person: {
      fiscalCode: person?.generalita?.codiceFiscale?.codFiscale || undefined,
      surname: person?.generalita?.cognome || undefined,
      withoutSurname: person?.generalita?.senzaCognome === '1' ? true : false,
      name: person?.generalita?.nome || undefined,
      withoutName: person?.generalita?.senzaNome === '1' ? true : false,
    },
    generality: {
      validityFiscalCode: person?.generalita?.codiceFiscale?.validitaCF || undefined,
      validityDateFiscalCode: person?.generalita?.codiceFiscale?.dataAttribuzioneValidita
        ? DateTime.fromISO(person?.generalita?.codiceFiscale?.dataAttribuzioneValidita)
        : null,
      birthChoiceDate:
        transformToChoiceDate(
          person?.generalita?.senzaGiorno,
          person?.generalita?.senzaGiornoMese
        ) || null,
      birthDate: person?.generalita?.dataNascita
        ? DateTime.fromISO(person?.generalita?.dataNascita)
        : null,
      gender: person?.generalita?.sesso || undefined,
      expatriationYear: person?.generalita?.annoEspatrio
        ? DateTime.fromISO(person?.generalita?.annoEspatrio).toFormat('dd/MM/yyyy')
        : undefined,
      isForeign: person?.generalita?.luogoNascita?.localita ? true : false,
      italian: {
        municipality: {
          description: person?.generalita?.luogoNascita?.comune?.nomeComune || '',
          province: person?.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
          provinceCode: person?.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || undefined,
          id: person?.generalita?.luogoNascita?.comune?.codiceIstat || undefined,
        },
        location: person?.generalita?.luogoNascita?.comune?.descrizioneLocalita || undefined,
        province: person?.generalita?.luogoNascita?.comune?.siglaProvinciaIstat || '',
      },
      foreign: {
        province: person?.generalita?.luogoNascita?.localita?.provinciaContea || '',
        state: {
          id: person?.generalita?.luogoNascita?.localita?.codiceStato || '',
          value: person?.generalita?.luogoNascita?.localita?.descrizioneStato || '',
        },
        municipality: person?.generalita?.luogoNascita?.localita?.descrizioneLocalita
          ? {
              id: '',
              province: person?.generalita?.luogoNascita?.localita?.provinciaContea || '',
              description: person?.generalita?.luogoNascita?.localita?.descrizioneLocalita,
            }
          : undefined,
      },
      exceptionalBirthPlace: person?.generalita?.luogoNascita?.luogoEccezionale || undefined,

      municipalityIdentifier:
        person?.generalita?.idSchedaSoggettoComune?.idSchedaSoggetto || undefined,
      istatCode: person?.generalita?.idSchedaSoggettoComune?.idSchedaSoggettoComuneIstat || '',
      anprIdentifier: person?.generalita?.idSchedaSoggettoANPR || undefined,
      note: person?.generalita?.note || undefined,
      aire: person?.generalita?.soggettoAIRE || undefined,
    },
  };

  return response;
};
